'use strict';

function getKeys(obj) {
  return Object.keys(obj);
}

module.exports = getKeys;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/getKeys.js
// module id = 43
// module chunks = 0